import StatusErrorPage from '@components/Error/StatusErrorPage';

function Error({ statusCode }: { statusCode: number }) {
  return <StatusErrorPage code={statusCode || 404} />;
}

// @ts-ignore
Error.getInitialProps = ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode };
};

export default Error;
